import iris_render from '@xgate/sg1-iris'
import '../scss/sg1.scss'
import { SG1Logs } from './modules/logs.js'
import { accessibility } from './modules/accessibility.js'
import { cyclope } from './modules/cyclope.js'
import { getApiUrl } from './modules/getApiUrl'

// Components
import { AdsLiensCommerciaux } from '../components/ads-liens-commerciaux/ads-liens-commerciaux.jsx'
import { AlertInfo } from '../components/alert-info/alert-info.jsx'
// import { BandeAccueil } from '../components/bande-accueil/bande-accueil.jsx'
import { BandeAccueilTv, bandeAccueilTvState } from '../components/bande-accueil-tv/bande-accueil-tv.jsx'
// import { Bandeau } from '../components/bandeau/bandeau.jsx'
import { BandeEcommerce } from '../components/bande-ecommerce/bande-ecommerce.jsx'
import { BandeEquipements } from '../components/bande-equipements/bande-equipements.jsx'
import { BandeListeContrats } from '../components/bande-liste-contrats/bande-liste-contrats.jsx'
import { BandeOptionsEquipement, bandeOptionsEquipementState } from '../components/bande-options-equipement/bande-options-equipement.jsx'
import { BandeParcoursMarchand } from '../components/bande-parcours-marchand/bande-parcours-marchand.jsx'
import { BonsPlans } from '../components/bons-plans/bons-plans.jsx'
import { Campagne } from '../components/campagne/campagne.jsx'
import { Carrousel } from '../components/carrousel/carrousel.jsx'
import { EditoTv } from '../components/edito-tv/edito-tv.jsx'
import { FilAriane } from '../components/fil-ariane/fil-ariane.jsx'
// import { Foisonnement } from '../components/foisonnement/foisonnement.jsx'
import { Hello } from '../components/hello/hello.jsx'
import { HabillageFond } from '../components/habillage-fond/habillage-fond.jsx'
import { JeuxVideo } from '../components/jeux-video/jeux-video.jsx'
// import { MagTv } from '../components/mag-tv/mag-tv.jsx'
import { MentionsLegales } from '../components/mentions-legales/mentions-legales.jsx'
import { Menu } from '../components/menu/menu.jsx'
import { MenuOse } from '../components/menu-ose/menu-ose.jsx'
import { MessageConnexion } from '../components/message-connexion/message-connexion.jsx'
import { Metadata, metaDataState } from '../components/metadata/metadata.jsx'
import { Music, musicState } from '../components/music/music.jsx'
import { News3x, news3xState } from '../components/news-3x/news-3x.jsx'
import { OffresComplementaires } from '../components/offres-complementaires/offres-complementaires.jsx'
import { ParcoursNouveauteInternet } from '../components/parcours-nouveaute-internet/parcours-nouveaute-internet.jsx'
import { ParcoursNouveautePlus } from '../components/parcours-nouveaute-plus/parcours-nouveaute-plus.jsx'
import { PrefooterSeo } from '../components/prefooter-seo/prefooter-seo.jsx'
import { Publicite } from '../components/publicite/publicite.jsx'
// import { BandePushFidelisation } from '../components/bande-push-fidelisation/bande-push-fidelisation.jsx'
import { Re } from '../components/re/re.jsx'
import { ReassuranceBoutique } from '../components/reassurance-boutique/reassurance-boutique.jsx'
import { ReassuranceEquipement, reassuranceEquipementState } from '../components/reassurance-equipement/reassurance-equipement.jsx'
import { ReassuranceReseau } from '../components/reassurance-reseau/reassurance-reseau.jsx'
import { ReassuranceService } from '../components/reassurance-service/reassurance-service.jsx'
import { RecoEquipements, recoEquipementsState } from '../components/reco-equipements/reco-equipements.jsx'
import { RecoParcoursProspect } from '../components/reco-parcours-prospect/reco-parcours-prospect.jsx'
import { ReassuranceTv } from '../components/reassurance-tv/reassurance-tv.jsx'
// import { SecondContract } from '../components/second-contract/second-contract.jsx'
import { SeoKeywords } from '../components/seo-keywords/seo-keywords.jsx'
import { StoreLocator } from '../components/store-locator/store-locator.jsx'
import { StratMarque } from '../components/strat-marque/strat-marque.jsx'
import { TvLiveReplay, tvLiveReplayState } from '../components/tv-live-replay/tv-live-replay.jsx'
import { Vitrine, vitrineState } from '../components/vitrine/vitrine.jsx'
import { Vod, vodState } from '../components/vod/vod.jsx'

// DisplayRules : Règles metier d'affichage de la page
const displayRules = (config, data) => {
   if (data.id === 'metaData' && data.zones[0].id === 'metaData') {
      let tempsFort = data.zones[0].data.technical.isTempsFort
      let hasZoneEvent = data.zones[0].data.technical.zoneEvent !== ''
      if ((tempsFort && hasZoneEvent)) {
         // 1. On change la couleur de fond de Hello en grey
         config.events.hello.data.background = 'grey'
         // 2. On masque le titre de Vitrine
         config.events.vitrineClient.data.hideTitle = true
      }
   }
}

/*
 * Config.events Options
 *
 *  - check             {array}         vérifie que les données du tableau sont bien présentes
 *  - component         {Component}     composant à afficher
 *  - data              {object}        données supplémentaires à passer au composant
 *  - dynamicPosition   {boolean}       si true, utilise la position dynamique
 *  - elementId         {string}        id de l'élément dans le DOM
 *  - noData            {boolean}       si true, ne vérifie pas les données
 *  - orchestrator      {function}      fonction spécifique d'orchestration
 *  - state             {signal}        si présent, utilise le state pour afficher le composant
 *  - shadowDOM         {boolean}       si true, utilise le shadowDOM pour afficher le composant
 *  - shadowStyle       {string}        si présent, injecte le style dans le shadowDOM
 */
let config = {
   apiUrl: '',
   displayRules: displayRules,
   loadHarmony: true,
   mock: '',
   events: {
      alerteInfo: { elementId: 'alertInfo', component: AlertInfo },
      bandeAccueilTv: {
         state: bandeAccueilTvState,
         elementId: 'bandeAccueilTv',
         component: BandeAccueilTv,
         data: { marginBottom: '', format: '1200x388-960x1040', elementId: 'bandeAccueilTv' },
      },
      BandeListesContrats: { elementId: 'listeContrats', component: BandeListeContrats, data: { segRefZ: 'boutique' } },
      bonsPlans: { elementId: 'bonsPlans', component: BonsPlans },
      campagne: { elementId: 'campagne', component: Campagne },
      carrousel: { elementId: 'carrousel', component: Carrousel, data: { marginBottom: '', format: '1440x310-960x1040', elementId: 'carrousel' } },
      // carrousel_hpRegulier: { elementId: 'carrousel', component: Carrousel, data: { marginBottom: 'mb-0 mb-md-2', format: '1440x310-960x1040' } },
      // carrousel_hpOccasionnel: { elementId: 'carrousel', component: Carrousel, data: { marginBottom: 'mb-0 mb-md-2', format: '1440x310-960x1040' } },
      carrousel_boutique: { elementId: 'carrousel', component: Carrousel, data: { marginBottom: 'mb-2', format: '1440x310-960x1040', elementId: 'carrousel' } },
      editoTv: { elementId: 'editoTv', component: EditoTv },
      equipments: { elementId: 'bandeEquipements', component: BandeEquipements, dynamicPosition: true, check: ['items'] },
      // event: { elementId: 'event', component: Bandeau, data: { closeButton: true } },
      filAriane: { elementId: 'filAriane', component: FilAriane, check: ['items'] },
      // foisonnement: { elementId: 'foisonnement', component: Foisonnement },
      hello: { elementId: 'hello', component: Hello, check: ['title'], data: {} }, // data used in displayRules
      habillage: { elementId: 'habillageFond', component: HabillageFond },
      jeuxVideo: { elementId: 'jeuxVideo', component: JeuxVideo, check: ['URL'] },
      legalNotices: { elementId: 'mentionsLegales', component: MentionsLegales, check: ['notes'] },
      // magTv: { elementId: 'magTv', component: MagTv },
      menu: { elementId: 'menu', component: Menu, check: ['items'] },
      menuOse: { elementId: 'menuOse', component: MenuOse },
      messageConnexion: { elementId: 'messageConnexion', component: MessageConnexion },
      metaData: { state: metaDataState, elementId: 'head', component: Metadata },
      music: { state: musicState, elementId: 'music', component: Music },
      news: {
         state: news3xState,
         elementId: 'news',
         component: News3x,
         dynamicPosition: true,
      },
      offreEtOptions: { state: bandeOptionsEquipementState, elementId: 'bande-options', component: BandeOptionsEquipement },
      offresComplementaires: { elementId: 'offresComplementaires', component: OffresComplementaires },
      parcours: { elementId: 'recoParcoursProspect', component: RecoParcoursProspect, check: ['items'] },
      // parcoursMarchand: { elementId: 'bande-parcours-marchand', component: BandeParcoursMarchand, check: ['recommendations'] },
      parcoursMarchandNouveauteInternet: { elementId: 'bande-parcours-nouveaute-internet', component: ParcoursNouveauteInternet, check: ['cards'] },
      parcoursMarchandNouveauteInternetProspect: { elementId: 'parcoursNouveautePlusInternetFix', component: ParcoursNouveautePlus, check: ['items'] },
      parcoursMarchandNouveauteMobileProspect: { elementId: 'parcoursNouveautePlusMobileForfait', component: ParcoursNouveautePlus, check: ['items'] },
      parcoursNouveaute: { elementId: 'parcours4nouveautes', component: BandeParcoursMarchand, check: ['recommendations'] },
      pourquoiChoisirOrange: { elementId: 'reassuranceBoutique', component: ReassuranceBoutique, check: ['items'] },
      prefooter: { elementId: 'prefooterSeoTmp', component: PrefooterSeo },
      pubLienscommerciaux: { elementId: 'pubLienscommerciaux', component: AdsLiensCommerciaux },
      pubMastheadTop: { elementId: 'pubMastheadTop', component: Publicite, data: { type: 'mastheadTop' } },
      // pubMasthead1: { elementId: 'pubMasthead1', component: Publicite, data: { type: 'masthead1' } },
      // pubMasthead2: { elementId: 'pubMasthead2', component: Publicite, data: { type: 'masthead2' } },
      // pubNative: { elementId: 'pubNative', component: Publicite, data: { type: 'native' } },
      // pubRM: { elementId: 'pubRm', component: Publicite, data: { type: 'rm' } },
      // pushFidelisation: { elementId: 'pushFidelisation', component: BandePushFidelisation, check: ['recommendations'] },
      rassuranceEcommerce: { elementId: 'ecommerce', component: BandeEcommerce, check: ['items'] },
      rassuranceReseau: { elementId: 'reassuranceReseau', component: ReassuranceReseau },
      rassuranceService: { elementId: 'rassuranceService', component: ReassuranceService, check: ['items'] },
      rassuranceTv: { elementId: 'reassuranceTv', component: ReassuranceTv },
      re: { elementId: 're', component: Re },
      reassuranceEquipments: { state: reassuranceEquipementState, elementId: 'reassuranceEquipement', component: ReassuranceEquipement, dynamicPosition: true, check: ['items'] },
      recoEquipements: { state: recoEquipementsState, elementId: 'recoEquipements', component: RecoEquipements, dynamicPosition: true },
      // secondContract: { elementId: 'secondContract', component: SecondContract },
      seoKeywords: { elementId: 'seoKeywords', component: SeoKeywords },
      storeLocator: { elementId: 'storeLocator', component: StoreLocator, noData: true },
      stratMarque: { elementId: 'stratMarque', component: StratMarque, noData: true },
      tv: { state: tvLiveReplayState, elementId: 'tvLiveReplay', component: TvLiveReplay },
      vod: { state: vodState, elementId: 'vod', component: Vod, check: ['items'] },
      vitrine: {
         elementId: 'vitrine',
         component: Vitrine,
         data: { grid: { name: 'prospect', tilesSize: ['double', 'simple', 'simple', 'simple', 'simple', 'double'] } },
      },
      vitrineClient: {
         state: vitrineState,
         elementId: 'vitrine',
         component: Vitrine,
         dynamicPosition: true,
         data: { grid: { name: 'client', tilesSize: ['double', 'simple', 'simple', 'simple', 'simple', 'simple', 'simple'] }, liensVoirTout: false },
      },
      // zonePerso: { elementId: 'zonePerso', component: BandeAccueil },
   },
}

window.dataStoreHP = {}

document.addEventListener('sg1_sseConnected', (event) => {
   window.dataStoreHP.SSEstatus = 'connected'
})

document.addEventListener('sseEndOfTransmition', (event) => {
   accessibility()

   setTimeout(() => {
      window.prerenderReady = true // pour prerender.io
   }, 10000)

   window.dataStoreHP.SSEstatus = 'disconnected'
})

SG1Logs.init()
var scriptUrl = document.currentScript.src
var url = new URL(scriptUrl)
var profile = url.searchParams.get('profile')
var context = url.searchParams.get('context')
config.apiUrl = getApiUrl(profile, context)
config = cyclope(config)
iris_render(config, profile, context)
